import React from "react";
import "../styles/TicketOptionsPage.css";
import AEC from "../assets/images/company-ticket-logos/AEC transport.png"
import upload from "../assets/svgs/upload.svg"
import uploadIcon from "../assets/svgs/upload-icon.svg"
import tinyBus from "../assets/svgs/tiny-bus.svg"
import sink from "../assets/svgs/sink.svg"



const TicketOptions = () => {
    return (
        <>
            <main className="ticket-options-main">
                <div className="ticket-options-content">
                    <section className="ticket-details">
                        <h2>ONE WAY</h2>
                        <section className="ticket-dates">
                            <img src={AEC} alt="" />
                            <p>Thursday, April 13 2023 </p>
                            <p>10:00am - 6:00pm</p>
                        </section>
                        <section className="ticket-venues">
                            <p>Lagos, Ikeja station</p>
                            <p>Abuja, Wuse 2 station</p>
                        </section>
                        {/* <section className="ticket-time">
                            <div className="to-fro">
                                <p>10:00 AM</p>
                                <small>8hr 0mins</small>
                                <p>6:00 PM</p>
                            </div>
                            <div className="iconic-representation"></div>
                            <div className="venue-to-fro"></div>
                        </section> */}
                        
                    </section>
                    <button className="locate-bus-stop">
                        Locate bus stop
                    </button>
                    <section className="trip-info">
                        <h2>
                        Trip info
                        </h2>
                        <div className="trip-info-slider">
                            <div className="headers">
                                <h2>General info</h2>
                                <h2>Cancellations</h2>
                                <h2>Luggage</h2>
                            </div>
                            <div className="content">
                                <p>Welcome aboard! We hope you enjoy your trip with us. For your convenience and safety, we kindly ask that you keep your seatbelt fastened at all times while the vehicle is in motion. Please also refrain from smoking or consuming alcohol on board. We ask that you use headphones when listening to music or watching videos to avoid disturbing other passengers.  Thank you for choosing our transportation service and we hope you have a pleasant trip.</p>
                                <p>Between 1 hrs to 2 hrs from the station departure time 15% cancellation charges. Passengers are required to be at the departure point at least 30 minutes before the departure time shown on their tickets, confirmed tickets with seat number will be surcharged by 50% of fare if the passenger fails to turn up 30 minutes before departure. The canceled trip by passengers shall attract a service charge of 15%, provided cancellation is made at least 30 minutes before the departure.</p>
                                <p>Please note that each passenger is allowed to bring one piece of luggage and one carry-on item on board. Any additional luggage or oversized items may be subject to additional fees or restrictions. Please ensure that your luggage meets the size and weight requirements, and that all items are securely packed.If you need assistance with your luggage, our team is happy to help. Thank you for your cooperation.</p>
                            </div>
                        </div>
                    </section>
                </div>
                    <div className="receipt-and-seating">
                        <div className="ticket-wrapper">
                            <div className="ticket">
                                <p>Tickets (1 passenger)</p>
                                <p>&#8358; 13000</p>
                            </div>
                            <div className="tax">
                                <p>Tax</p>
                                <p>&#8358; 230</p>
                            </div>
                            <div className="divider"></div>
                            <div className="total">
                                <p>Total</p>
                                <p>&#8358; 13230</p>
                            </div>
                        </div>
                        <button className="share-journey-details">
                            <div>
                                <img src={uploadIcon} alt="" />
                            </div>
                            <p>Share journey details</p>
                        </button>
                        {/* <section className="seat-selection">
                            <div>
                                <table className="seat-selection-table">
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                </table>
                                <div className="seat-selection-key"></div>
                            </div>
                            <button>Continue to passenger details</button>
                        </section> */}
                    </div>
            </main>
        </>
    );
}
export default TicketOptions;